import React from 'react';
import './Globalagents.css';
import Globalagen from '../../imgs/globalagent.webp';

const Globalagents = () => {
    return (
        <div className="Rotaryinj-container">
            <div className='Ordinarys'>
                <h2 className="Rotaryinj-title">GLOBAL AGENT NETWORK</h2>
                <div className="Mostcountr">
                    
                    <img src={Globalagen} alt="72 Cavity PET Preforms Machine" className="Rotaryi-image" />

                </div>



            </div>

        </div>
    );
};

export default Globalagents;
